import { JobseekerModel } from './jobseeker-model';
import { Serializable } from '@admin/core/models/serializable';

export class JobseekerGetResult implements Serializable<JobseekerGetResult> {
  fromObject(obj: any): JobseekerGetResult {
    Object.assign(this, obj);

    let jobseeker = new JobseekerModel();
    if (obj.success) {
      this.payload = jobseeker.fromObject(obj.payload);
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public success: boolean;
  public error: string;
  public errorCode: number;
  public payload: JobseekerModel;
}
